// extracted by mini-css-extract-plugin
export default {"container":"Trailer_container__UDj6o","img":"Trailer_img__QGnPD","text":"Trailer_text__LJDUM"};